(() => {
  'use strict';
  function initialize(scope = document) {
    scope.querySelectorAll('[data-yc-product-media]').forEach(gallery => {
      if (gallery.dataset.enhanced === 'true') return;
      const trigger = gallery.querySelector('[data-yc-media-trigger]');
      const dialog = document.getElementById(trigger?.getAttribute('aria-controls'));
      const image = dialog?.querySelector('[data-yc-media-image]');
      const closeButton = dialog?.querySelector('[data-yc-media-close]');
      if (!trigger || !dialog || !image || !closeButton || typeof dialog.showModal !== 'function') return;
      gallery.dataset.enhanced = 'true';
      let backdropPress = false;
      function restoreFocus() {
        backdropPress = false;
        trigger.setAttribute('aria-expanded', 'false');
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      }
      function close() {
        if (dialog.open) dialog.close();
        restoreFocus();
      }
      function outside(event) {
        if (event.target !== dialog) return false;
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }
      trigger.addEventListener('click', event => {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (document.querySelector('dialog[open]')) return;
        if (!image.getAttribute('src')) image.setAttribute('src', image.dataset.src);
        backdropPress = false;
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        closeButton.focus();
      });
      closeButton.addEventListener('click', close);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', restoreFocus);
      dialog.addEventListener('pointerdown', event => { backdropPress = outside(event); });
      dialog.addEventListener('click', event => { if (backdropPress && outside(event)) close(); backdropPress = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
